var htmlDecode = require('html-entities').Html5Entities.decode;

angular.module('account.my-articles', [
        'security.authorization',
        'services.adminResource',
        'resources.Article',
        'ngTagsInput',
        'resources.Tag',
        'resources.User',
        'resources.Category',
        'config',
        'services.algoliaResource',
        'services.localizedMessages',
    ])

    .config(["$stateProvider", function ($stateProvider) {
        $stateProvider
            .state('account.my-articles', {
                url: '/my-articles',
               title: 'Manage Articles',
                views: {
                    'main@': {
                        template: require('../../common/templates/articles.tpl.html'),
                        controller: 'MyArticlesController'
                    }
                }
            });
    }])

    .controller('MyArticlesController',
        ["$scope", "$route", "$location", "$log", "utility", "STATUSES", "ARTICLE_STYLES", "APP_IMG_URLS", "Category", "Tag", "Article", "socket", "algoliaResource", "localizedMessages", function ($scope, $route, $location, $log, utility, STATUSES, ARTICLE_STYLES, APP_IMG_URLS, Category, Tag,Article, socket, algoliaResource, localizedMessages) {
            $scope.localizedMessages = localizedMessages;
            STATUSES = STATUSES.map( (status) => Object.assign(status, { value: localizedMessages.get(status.value) }) );
            $scope.imgUrl200 = APP_IMG_URLS['200'];
            $scope.imgUrlNoPhoto = APP_IMG_URLS['NO_PHOTO_200'];

            $scope.dataLoaded = false;
            $scope.loadTags = function (query) {
                return Tag.search({q: query}).$promise.then(function (tags) {
                    if (!tags) return [];
                    return tags.map(function (tag) {
                        return {
                            _id: tag._id,
                            text: tag.name,
                            name: tag.name,
                            sefriendly: slugify(tag.name)
                        }
                    })
                });
            };
            // $scope.loadAutors = function (query) {
            //     return User.search({q: query}).$promise.then(function (users) {
            //         if (!users) return [];
            //         return users.map(function (user) {
            //             return {
            //                 _id: tag._id,
            //                 text: tag.name,
            //                 name: tag.name,
            //                 sefriendly: slugify(tag.name)
            //             }
            //         })
            //     });
            // };

            var slugify = function (text) {
                if (typeof text !== 'string') return text;
                return text.toString()
                    .toLowerCase()
                    .replace(/á/g, 'a')
                    .replace(/é/g, 'e')
                    .replace(/í/g, 'i')
                    .replace(/ó/g, 'o')
                    .replace(/ú/g, 'u')
                    .replace(/ã/g, 'a')
                    .replace(/ñ/g, 'n')
                    .replace(/ç/g, 'c')
                    .replace(/ü/g, 'u')
                    .replace(/^\s+|\s+$/g, "")
                    .replace(/[_|\s]+/g, "-")
                    .replace(/[^a-z\u0400-\u04FF0-9-]+/g, "")
                    .replace(/[-]+/g, "-")
                    .replace(/^-+|-+$/g, "");
            };

            $scope.$watchCollection('data.categories', function (newVal, oldVal) {
                var temp = ""
                if (newVal) {
                    newVal.forEach(function (category) {
                        temp += "," + category.id;
                    })
                    $scope.query.categories = temp.replace(',', '');
                }
            });
            $scope.tempTags = [];
            $scope.applyFilters = function () {
                for (name in $scope.temp) {
                    if(name == 'keywords'){
                        $scope.query[name] = $scope.temp[name].replace(/  /g," ").split(' ');
                        continue;
                    }
                    if(name == 'tags'){
                        $scope.tempTags = [];
                        $scope.temp[name].forEach(function(tag){
                            $scope.tempTags.push(tag.name);
                        })
                        $scope.query[name] = $scope.tempTags.join(',');
                        $scope.tempTags = $scope.temp[name];
                        $scope.temp[name] = [];
                        continue;
                    }
                    if(name == 'categories'){
                        var temp = [];
                        $scope.temp[name].forEach(function(categories){
                            temp.push(categories.id);
                        })
                        $scope.query[name] = temp.join(',');
                        continue;
                    }
                    $scope.query[name] = $scope.temp[name];
                }
                $scope.query.skip = 0;
               // $scope.resetFilters();
                // console.log( '>>>1', $scope.query );
                Article.query($scope.query).$promise.then(function (data) {
                    deserializeData(data);
                    //update url in browser addr bar
                    $location.search($scope.query);
                    $scope.temp['tags'] = $scope.tempTags;
                }, function (e) {
                    $log.error(e);
                });
            }
            $scope.resetFilters = function () {
                for (name in $scope.temp) {
                    if(Array.isArray($scope.temp[name])){
                        $scope.temp[name] = [];
                        continue;
                    }
                    $scope.temp[name] = "";
                }
            }

            //add info about users who edit some articles
            socket.on('editUpdate', function (data) {
                if (data && $scope.articles) {
                    for (var i = 0; i < $scope.articles.length; i++) {
                        if (data[$scope.articles[i].article_id + "_"] && data[$scope.articles[i].article_id + "_"].length) {
                            $scope.articles[i].editing = "editing by: " + data[$scope.articles[i].article_id + "_"][0].replace(/\/.*/, '');
                        } else {
                            $scope.articles[i].editing = "";
                        }
                        if (data[$scope.articles[i].article_id + "_"] && data[$scope.articles[i].article_id + "_"].length) {
                            $scope.articles[i].watching = "watching by: ";
                            for(var j = 1; j < data[$scope.articles[i].article_id + "_"].length; j++){
                                $scope.articles[i].watching += data[$scope.articles[i].article_id + "_"][j].replace(/\/.*/, '') + "  ";
                            }
                        } else {
                            $scope.articles[i].watching = "";
                        }
                    }
                }
            });
            // local var
            var deserializeData = function (data) {
                if (!data) return;
                $scope.page = data.meta.page;
                $scope.query = data.meta.query;
                $scope.articles = data.data.map(function(article){
                  // console.log( '>>', article );
                    article.title = htmlDecode(article.title);
                    return article;
                });
            };

            $scope.query = _.assign({limit: 50, skip: 0}, $location.search());
						$scope.statuses = STATUSES;
						$scope.statuses.map(s => {
							s.value = s.value.split("?").join('');
						});
            $scope.article_styles = ARTICLE_STYLES;
            $scope.sorts = [
                {label: "id \u25B2", value: "_id"},
                {label: "id \u25BC", value: "-_id"},
                {label: "name \u25B2", value: "name"},
                {label: "name \u25BC", value: "-name"}
            ];
            $scope.limits = [
                {label: "10 Materiałów", value: 10},
                {label: "20 Materiałów", value: 20},
                {label: "50 Materiałów", value: 50},
                {label: "100 Materiałów", value: 100}
            ];


            $scope.fetchArticles = function (offset) {
                $scope.query.skip = offset;
            };

            $scope.dropStatus = 17;
            $scope.chosenLocale = '1234';
            Article.query({
                status: $scope.dropStatus,
                edition: $scope.chosenLocale,
                sort: "orderNumber"
            }).$promise.then(function (data) {
//                console.log( '>>>', data );
                $scope.mainArticles = data.data;

            }, function (e) {
                $log.error(e);
            });

            $scope.getArticlesByStatus = function (statusCode, edition) {
								console.log('params', statusCode, edition);
                $scope.dropStatus = statusCode;
                Article.query({
                    status: statusCode,
                    edition: edition,
                    sort: "orderNumber"
                }).$promise.then(function (data) {
                    $scope.mainArticles = data.data;
                }, function (e) {
                    $log.error(e);
                });
            }

            $scope.saveOrder = function () {
                setTimeout(function(){
                    growl.info('Order saved!');
                }, 500);
                $scope.mainArticles.forEach(function(article, index){
                    article.orderNumber = index;
                    Article.update(article, function (result) {console.log('saved');
                    });
                })
            }

            $scope.dropToMainCallback = function (event, index, item, external, type) {
                item.status = $scope.dropStatus;
                item.edition = $scope.chosenLocale;
                // Article.update(item, function (result) {}).$promise.then(function () {});
                return item;
            }
            $scope.dropToMyCallback = function (event, index, item, external, type) {
                item.status = 1;
                // Article.update(item, function (result) {}).$promise.then(function () {});
                return item;
            }
            $scope.$watchCollection('locale', function (newState, oldState) {

                if( newState || typeof( newState ) != 'object' ){
                    return;
                }
                // console.log( '>>>', newState );
                $scope.chosenLocale = newState.sefriendly;
                Article.query({
                    status: $scope.dropStatus,
                    edition: $scope.chosenLocale,
                    sort: "orderNumber"
                }).$promise.then(function (data) {
                    $scope.mainArticles = data.data;

                }, function (e) {
                    $log.error(e);
                });
            })

            var queryTimer = null;
            var endFlag = true;
            $scope.$watchCollection('query', function (newState, oldState) {
                if (angular.equals(newState, oldState)) {
                    return;
                }

                if (!queryTimer && endFlag) {
                    queryTimer = setTimeout(function () {
                        endFlag = false;
                        Article.query($scope.query).$promise.then(function (data) {

                            deserializeData(data);
                            //update url in browser addr bar
                            $location.search($scope.query);
                            queryTimer = null;
                            endFlag = true;
                        }, function (e) {
                            $log.error(e);
                            endFlag = true;
                        });
                    }, 50)
                } else if (endFlag) {
                    clearInterval(queryTimer);
                    queryTimer = setTimeout(function () {
                        Article.query($scope.query).$promise.then(function (data) {
                            deserializeData(data);
                            //update url in browser addr bar
                            $location.search($scope.query);
                            queryTimer = null;
                        }, function (e) {
                            $log.error(e);
                        });
                    }, 50)
                }
            });

            // $scope vars
            //select elements and their associating options
            $scope.getLabel = function (status) {
                var status = _.find(STATUSES, {id: status + ''});
                return status ? status.value : '';
						};
						
            $scope.getStyle = function (status) {
                var status = _.find(STATUSES, {id: status + ''});
                return {
                    color: status ? status.color : '',
                    background: status ? status.background : ''
                }
            };
            $scope.query.sort = /*'created_at';*/"created_at-";
            Article.query($scope.query).$promise.then(function (data) {

                deserializeData(data);
                //update url in browser addr bar
                $location.search($scope.query);
            }, function (e) {
                $log.error(e);
            });

            async.parallel({
                categories: function (cb) {
                    var options = [];
                    var generateCategoryOptions = function (items, container) {
                        items.forEach(function (item) {
                            if (!item.path) {
                                return;
                            }
                            var depth = item.path.split('/').filter(Boolean).length;
                            var indent = (new Array(5)).join(String.fromCharCode(160));
                            container.push({
                                _id: item._id,
                                id: item.id,
                                path: item.path,
                                sefriendly: item.sefriendly,
                                parent: item.parent,
                                parent_id: item.parent_id,
                                name: item.name,
                                _name: (new Array(depth)).join(indent) + (depth>1 ? '- ' : '') + item.name
                            });
                            if (item.children) {
                                generateCategoryOptions(item.children, container);
                            }
                        });
                        return container;
                    };
                    Category.getPermittedTree().$promise.then(function (data) {
                        generateCategoryOptions(data, options);
                        cb(null, options);
                    });
                }
            }, function (err, results) {
                if (err) return console.log(err);
                $scope.dataLoaded = true;
                $scope.categories = results.categories;
            });

            $scope.algoliaReindexing = function() {
                algoliaResource.indexingArticles().then((result) =>{
                    $scope.algoliaSuccess = true;
                }).catch((error) => {
                    $scope.algoliaError = true;
                })
            }
        }]);



// WEBPACK FOOTER //
// ./client/src/app/account/my-articles/my-articles.js